import { createSelector } from 'reselect';
import _ from 'lodash';

import { Constant } from './../../config/constant';

const selectedSyllabus: any = (state: any) => state.setContextData.selectedSyllabus;

export const getCurrentSyllabusStatus = createSelector(selectedSyllabus, (currentSyllabus: any) => {
    return (currentSyllabus?.syllabusStatus === 'Submitted') ? true: false;
});